exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.validation-error[data-v-4e4e0021] {\n    color: #ee653b;\n    font-family: \"proxima-nova\";\n    font-size: 12px;\n    font-weight: bold;\n    display: block;\n    top: 14px;\n    right: 45px;\n}\n.floating-label[data-v-4e4e0021] {\n    padding-left: 2px !important;\n}\n#reset-password-success-msg[data-v-4e4e0021] {\n    margin-bottom: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-4e4e0021&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./modules/forgot-password/ForgotPassword.vue
// module id = 2675
// module chunks = 40